import React from "react";
import { Box, styled } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarHalfRoundedIcon from "@mui/icons-material/StarHalfRounded";
import { motion } from "framer-motion";
import { useLocation } from "react-router";

const Rating = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  // marginBottom: '8px'
}));

const Stars = styled("div")(({ theme }) => ({
  color: "#FFB800",
  alignItems: "center",
  display: "flex",
}));

const RatingNumber = styled(Box)(({ theme }) => ({
  color: "#666",
  fontSize: "16px",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));
const getStarFontSize = (routeName) => {
  if (routeName.includes("/listing")) {
    return { xs: "14px", sm: "16px", md: "18px" };
  } else if (routeName.includes("/products")) {
    return { xs: "16px", sm: "18px", md: "20px" };
  } else if (routeName.includes("/about")) {
    return { xs: "12px", sm: "14px", md: "16px" };
  } else {
    return { xs: "16px", sm: "18px", md: "20px" }; // default
  }
};

const Ratings = ({ value, styles, ratingNumberstyles }) => {
  const location = useLocation();
  const routeName = location.pathname;

  const maxStars = 5;
  // Ensure value is a valid number
  const numericValue = parseFloat(value) || 0;

  // Calculate the number of filled stars
  const filledStars = Math.floor(numericValue);

  // Determine if there's a half star
  const hasHalfStar = numericValue % 1 >= 0.5;

  // Calculate empty stars correctly
  const emptyStars = Math.max(
    maxStars - filledStars - (hasHalfStar ? 1 : 0),
    0
  );

  // Format the value to one decimal place
  const formattedValue = numericValue.toFixed(1);
  const starFontSize = getStarFontSize(routeName);

  return (
    <Rating>
      {/* <Stars>
        {[...Array(filledStars)].map((_, i) => (
          <StarRoundedIcon
            key={i}
            sx={{ color: "#FF9900", fontSize: "20px", ...styles }}
          />
        ))}
        {hasHalfStar && (
          <StarHalfRoundedIcon
            sx={{ color: "#FF9900", fontSize: "20px", ...styles }}
          />
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <StarBorderRoundedIcon
            key={i}
            sx={{ color: "#FF9900", fontSize: "20px", ...styles }}
          />
        ))}
      </Stars> */}
      <Stars>
        {[...Array(filledStars)].map((_, i) => (
          <motion.span
            key={`filled-${i}`}
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 10,
              delay: i * 0.2,
            }}
          >
            <StarRoundedIcon
              sx={{
                color: "#FF9900",
                fontSize: starFontSize,
                ...styles,
              }}
            />
          </motion.span>
        ))}

        {hasHalfStar && (
          <motion.span
            key="half"
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 10,
              delay: filledStars * 0.2,
            }}
          >
            <StarHalfRoundedIcon
              sx={{
                color: "#FF9900",
                fontSize: starFontSize,
                ...styles,
              }}
            />
          </motion.span>
        )}

        {[...Array(emptyStars)].map((_, i) => (
          <motion.span
            key={`empty-${i}`}
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 10,
              delay: (filledStars + (hasHalfStar ? 1 : 0) + i) * 0.1,
            }}
          >
            <StarBorderRoundedIcon
              sx={{
                color: "#FF9900",
                fontSize: starFontSize,
                ...styles,
              }}
            />
          </motion.span>
        ))}
      </Stars>

      <RatingNumber component="span" style={{ ...ratingNumberstyles }}>
        {formattedValue}
      </RatingNumber>
    </Rating>
  );
};

export default Ratings;
